import { TenantEntity } from '../TenantEntity'

export class FbaChargeScene extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FbaChargeScene'
  }

  get type1() {
    return this._data.type1
  }
  set type1(type1) {
    this._data.type1 = type1
  }
  get rule1() {
    return this._data.rule1
  }
  set rule1(rule1) {
    this._data.rule1 = rule1 || 0
  }
  get value1() {
    return this._data.value1
  }
  set value1(value1) {
    this._data.value1 = value1 || 0.0
  }
  get type2() {
    return this._data.type2
  }
  set type2(type2) {
    this._data.type2 = type2
  }
  get rule2() {
    return this._data.rule2
  }
  set rule2(rule2) {
    this._data.rule2 = rule2 || 0
  }
  get value2() {
    return this._data.value2
  }
  set value2(value2) {
    this._data.value2 = value2 || 0.0
  }
  get relationShip2() {
    return this._data.relationShip2
  }
  set relationShip2(relationShip2) {
    this._data.relationShip2 = relationShip2 || 0
  }
  get type3() {
    return this._data.type3
  }
  set type3(type3) {
    this._data.type3 = type3
  }
  get rule3() {
    return this._data.rule3
  }
  set rule3(rule3) {
    this._data.rule3 = rule3 || 0
  }
  get value3() {
    return this._data.value3
  }
  set value3(value3) {
    this._data.value3 = value3 || 0.0
  }
  get relationShip3() {
    return this._data.relationShip3
  }
  set relationShip3(relationShip3) {
    this._data.relationShip3 = relationShip3 || 0
  }
  get calcMethod() {
    return this._data.calcMethod
  }
  set calcMethod(calcMethod) {
    this._data.calcMethod = calcMethod || 0
  }
  get fixedExpenses() { // 固定费用值
    return this._data.fixedExpenses
  }
  set fixedExpenses(fixedExpenses) {
    this._data.fixedExpenses = fixedExpenses || 0.0
  }
  get param1() {
    return this._data.param1
  }
  set param1(param1) {
    this._data.param1 = param1
  }
  get mode2() {
    return this._data.mode2
  }
  set mode2(mode2) {
    this._data.mode2 = mode2 || 0
  }
  get param2() {
    return this._data.param2
  }
  set param2(param2) {
    this._data.param2 = param2
  }
  get mode3() {
    return this._data.mode3
  }
  set mode3(mode3) {
    this._data.mode3 = mode3 || 0
  }
  get param3() {
    return this._data.param3
  }
  set param3(param3) {
    this._data.param3 = param3
  }
  get chargeUuid() {
    return this._data.chargeUuid
  }
  set chargeUuid(chargeUuid) {
    this._data.chargeUuid = chargeUuid
  }
}
